export const FILES = {
  BENEFITS: "benefits",
  DEVICES: "devices",
  PLANS: "plans",
  EXTRAS: "extras",
  PICKED_PLANS: "picked_plans"
}

// Data actions
export const FETCH_DEVICES_BEGIN = "FETCH_DEVICES_BEGIN"
export const FETCH_DEVICES_SUCCESS = "FETCH_DEVICES_SUCCESS"
export const FETCH_DEVICES_FAILURE = "FETCH_DEVICES_FAILURE"

export const FETCH_PLANS_BEGIN = "FETCH_PLANS_BEGIN"
export const FETCH_PLANS_SUCCESS = "FETCH_PLANS_SUCCESS"
export const FETCH_PLANS_FAILURE = "FETCH_PLANS_FAILURE"

// The actions for grabbing plans when we're dealing with the pick summaries
export const FETCH_PICKED_PLANS_BEGIN = "FETCH_PICKED_PLANS_BEGIN"
export const FETCH_PICKED_PLANS_SUCCESS = "FETCH_PICKED_PLANS_SUCCESS"
export const FETCH_PICKED_PLANS_FAILURE = "FETCH_PICKED_PLANS_FAILURE"

export const FETCH_BENEFITS_BEGIN = "FETCH_BENEFITS_BEGIN"
export const FETCH_BENEFITS_SUCCESS = "FETCH_BENEFITS_SUCCESS"
export const FETCH_BENEFITS_FAILURE = "FETCH_BENEFITS_FAILURE"

export const FETCH_EXTRAS_BEGIN = "FETCH_EXTRAS_BEGIN"
export const FETCH_EXTRAS_SUCCESS = "FETCH_EXTRAS_SUCCESS"
export const FETCH_EXTRAS_FAILURE = "FETCH_EXTRAS_FAILURE"

// Journey navigation actions
export const FLAG_NEXT_PAGE = "FLAG_NEXT_PAGE"
export const FLAG_JUMP_PAGE = "FLAG_JUMP_PAGE"
export const FLAG_PREV_PAGE = "FLAG_PREV_PAGE"
export const FLAG_GOTO_FIRST_PAGE = "FLAG_GOTO_FIRST_PAGE"
export const FLAG_SUBMIT = "FLAG_SUBMIT"
export const UNSET_PAGE_FLAGS = "UNSET_PAGE_FLAGS"
export const FLAG_RESET_JOURNEY = "FLAG_RESET_JOURNEY"

// Basket handling actions
export const SELECT_DEVICE = "SELECT_DEVICE"
export const SELECT_PLAN = "SELECT_PLAN"
export const ADD_EXTRA = "ADD_EXTRA"
export const REMOVE_EXTRA = "REMOVE_EXTRA"
export const ADD_ENTERTAINMENT = "ADD_ENTERTAINMENT"
export const BUILT_PLAN = "BUILT_PLAN"
export const ADD_BENEFIT = "ADD_BENEFIT"
export const REMOVE_BENEFIT = "REMOVE_BENEFIT"
export const RESET_BASKET = "RESET_BASKET"

// Condition actions
export const SELECT_CONDITION = "SELECT_CONDITION"
export const SET_STORENAME = "SET_STORENAME"

// Replace Data actions
export const REPLACE_PLANS = "REPLACE_PLANS"
export const REPLACE_DEVICES = "REPLACE_DEVICES"
export const REPLACE_BENEFITS = "REPLACE_BENEFITS"
export const REPLACE_EXTRAS = "REPLACE_EXTRAS"

// Mutation action -- Call Prof X as this is gonna be a beast!
export const MUTATE_DATA = "MUTATE_DATA"

export const LOG_ACTION = "LOG_ACTION"

export const ALL_PLANS_BUTTON_CLICKED = "ALL_PLANS_BUTTON_CLICKED"
